<div class="filter-for-list">
  <h4>{{'JOB_TASK_TITLE'| translate}}  {{projectName}}</h4>
  <mat-form-field placement="right" [ngbTooltip]="'SEARCH_INPUT_TOOLTIP' | translate">
    <input matInput (keyup)="applyFilter($event.target.value)" [placeholder]="'SEARCH' | translate">
  </mat-form-field>
  <mat-slide-toggle class="sliderActiveList" (change)="toggle($event)" placement="right"
                    [ngbTooltip]="'JOB_TASK_COMPLETED_SLIDER_TOOLTIP' | translate"> {{ toggleLabel }}
  </mat-slide-toggle>
  <br clear="both"/>
</div>
<app-progressbar *ngIf="isLoading"></app-progressbar>

<table mat-table [dataSource]="jobTaskMatTableDataSource" matSort class="table-striped" style="width:100%">
  <ng-container matColumnDef="job_task_id">
    <th mat-header-cell *matHeaderCellDef mat-sort-header>{{'JOB_TASK_ID'|translate}}</th>
    <td mat-cell *matCellDef="let jobTask">
      {{jobTask.id }}
    </td>
  </ng-container>

  <ng-container matColumnDef="job_start_date">
    <th mat-header-cell *matHeaderCellDef mat-sort-header>{{'JOB_TASK_START_DATE'|translate}}</th>
    <td mat-cell *matCellDef="let jobTask">
      {{jobTask.start_date | date:'medium'}}
    </td>
  </ng-container>

  <ng-container matColumnDef="project_id">
    <th mat-header-cell *matHeaderCellDef mat-sort-header>{{'JOB_TASK_PROJECT_ID'|translate}}</th>
    <td mat-cell *matCellDef="let jobTask">
      {{jobTask.project_id}}
    </td>
  </ng-container>

  <ng-container matColumnDef="project_name">
    <th mat-header-cell *matHeaderCellDef mat-sort-header>{{'JOB_TASK_PROJECT_NAME'|translate}}</th>
    <td mat-cell *matCellDef="let jobTask">
      {{jobTask.project_name}}
    </td>
  </ng-container>

  <ng-container matColumnDef="resume">
    <th mat-header-cell *matHeaderCellDef mat-sort-header>{{'JOB_TASK_RESUME'|translate}}</th>
    <td mat-cell *matCellDef="let jobTask">
      <mat-chip-list>
        <mat-chip class="location"
                  [ngbTooltip]=" 'JOB_TASK_LOCATIONS'| translate"> {{jobTask.message?.location_ids.length}}</mat-chip>
        <mat-chip [ngbTooltip]="'JOB_TASK_DATE_START_EXPORT' | translate"> {{jobTask.message?.start_date}}</mat-chip>
        <mat-chip [ngbTooltip]="'JOB_TASK_DATE_END_EXPORT' | translate"> {{jobTask.message?.end_date}}</mat-chip>
        <mat-chip> {{jobTask.message?.data_type}}</mat-chip>
      </mat-chip-list>
    </td>
  </ng-container>

  <ng-container matColumnDef="progression">
    <th mat-header-cell *matHeaderCellDef mat-sort-header>{{'JOB_TASK_PROGRESS'|translate}}</th>
    <td mat-cell *matCellDef="let jobTask">
      <mat-progress-bar
        mode="determinate"
        [value]="jobTask?.progress"
        ngbTooltip="{{jobTask?.progress?  jobTask?.progress + '%' : ''}}">
      </mat-progress-bar>

    </td>
  </ng-container>

  <ng-container matColumnDef="status">
    <th mat-header-cell *matHeaderCellDef mat-sort-header>{{'JOB_TASK_STATUS'|translate}}</th>
    <td mat-cell *matCellDef="let jobTask">
      <div [ngbTooltip]="jobTask.status | jobTaskStatus: 'tooltip'" [ngClass]="jobTask.status | jobTaskStatus">
      </div>
    </td>
  </ng-container>

  <ng-container matColumnDef="actions">
    <th mat-header-cell *matHeaderCellDef id="actions">{{'ACTIONS'|translate}}</th>
    <td mat-cell *matCellDef="let jobTask; let i = index;">
      <app-button-download-export [object]="jobTask"></app-button-download-export>

      <button type="button" class="btn action-button"
              (click)="view(jobTask.id)"
              [ngbTooltip]="'JOB_TASK_INFORMATION' | translate">
        <fa-icon [icon]="faInfoCircle"></fa-icon>
      </button>

      <button *ngIf="jobTask.status === jobTaskStatus.STATUS_WARNING ||
                     jobTask.status === jobTaskStatus.STATUS_FAILED ||
                     jobTask.status === jobTaskStatus.STATUS_CANCELLED"
              type="button" class="btn action-button" style="background: darkgreen"
              (click)="openExportModal(jobTask)" placement="left"
              [ngbTooltip]="'CSV_EXPORT_TOOLTIP' | translate">
        <fa-icon [icon]="faFileExcel"></fa-icon>
      </button>

      <button *ngIf="jobTask.status === jobTaskStatus.STATUS_IN_PROGRESS ||
                     jobTask.status === jobTaskStatus.STATUS_SCHEDULED"
              type="button" class="btn action-button" style="background: red"
              (click)="cancel(jobTask.id, i)"
              placement="left"
              [ngbTooltip]="'DELETE_ICON_TOOLTIP' | translate">
        <app-progressbar *ngIf="showSpinner && i === spinnerRowIndex"></app-progressbar>
        <fa-icon [icon]="faTrashAlt"></fa-icon>
      </button>
    </td>
  </ng-container>

  <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
  <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>

</table>
<mat-paginator [pageSizeOptions]="pageSizeOptions" showFirstLastButtons [pageSize]="pageSize"></mat-paginator>

